export function fileNameFromHeaders(headers: any, customName: string = '') {
	const disposition = headers['content-disposition'];
	return disposition !== undefined ? disposition.split('=')[1] : customName;
}
